<div ngbDropdown
     placement="bottom-right">
  @if (isEditing) {
  <button class="btn btn-outline-primary border-0"
          (click)="selectEdit()">
    <fa-icon [icon]="['fas', 'times']"></fa-icon>
  </button>
  } @else {
  <button class="btn btn-outline-primary border-0"
          ngbDropdownToggle>
    <fa-icon [icon]="['fas', 'ellipsis-h']"></fa-icon>
  </button>
  <div ngbDropdownMenu>
    @if (canEdit) {
    <button ngbDropdownItem
            (click)="selectEdit()">Edit</button>
    
    <div class="dropdown-divider"></div>
    }
    <ng-content></ng-content>
  </div>
  }
</div>